import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import SpotifyEpisodes from "./spotify";

function PodPodCastItem({ objectList }) {
  const sectionRef = useRef(null);
  const [playMusic, setPlayMusic] = useState({});
  const [iframeError, setIframeError] = useState({});
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sectionRef.current && !sectionRef.current.contains(event.target)) {
        setPlayMusic({});
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const renderIcon = (value) => {
    let name = value?.toLowerCase();
    switch (name) {
      case "linkedin":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
              fill="#233642"
              d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248c-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586c.173-.431.568-.878 1.232-.878c.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252c-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"
            ></path>
          </svg>
        );
      case "twitter":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill="#233642"
              d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"
            ></path>
          </svg>
        );
      case "facebook":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="none">
              <g clipPath="url(#akarIconsFacebookFill0)">
                <path
                  fill="#233642"
                  fillRule="evenodd"
                  d="M0 12.067C0 18.034 4.333 22.994 10 24v-8.667H7V12h3V9.333c0-3 1.933-4.666 4.667-4.666c.866 0 1.8.133 2.666.266V8H15.8c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14V24c5.667-1.006 10-5.966 10-11.933C24 5.43 18.6 0 12 0S0 5.43 0 12.067"
                  clipRule="evenodd"
                ></path>
              </g>
              <defs>
                <clipPath id="akarIconsFacebookFill0">
                  <path fill="#fff" d="M0 0h24v24H0z"></path>
                </clipPath>
              </defs>
            </g>
          </svg>
        );
      case "instagram":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill="#233642"
              d="M11.95 1h.1c1.827 0 3.266 0 4.42.105c1.178.106 2.156.328 3.03.833A7 7 0 0 1 22.062 4.5c.505.874.727 1.852.833 3.03C23 8.684 23 10.123 23 11.95v.1c0 1.827 0 3.266-.105 4.42c-.106 1.178-.328 2.156-.833 3.03a7 7 0 0 1-2.562 2.562c-.874.505-1.852.727-3.03.833c-1.154.105-2.593.105-4.42.105h-.1c-1.827 0-3.266 0-4.42-.105c-1.178-.106-2.156-.328-3.03-.833A7 7 0 0 1 1.938 19.5c-.505-.874-.727-1.852-.833-3.03C1 15.316 1 13.877 1 12.05v-.1c0-1.827 0-3.266.105-4.42c.106-1.178.328-2.156.833-3.03A7 7 0 0 1 4.5 1.938c.874-.505 1.852-.727 3.03-.833C8.684 1 10.123 1 11.95 1M7.71 3.096c-1.039.095-1.691.274-2.21.574A5 5 0 0 0 3.67 5.5c-.3.519-.48 1.171-.574 2.21C3.001 8.764 3 10.112 3 12s.001 3.236.096 4.29c.095 1.039.274 1.691.574 2.21a5 5 0 0 0 1.83 1.83c.519.3 1.171.48 2.21.574c1.054.095 2.402.096 4.29.096s3.236-.001 4.29-.096c1.039-.095 1.691-.274 2.21-.574a5 5 0 0 0 1.83-1.83c.3-.519.48-1.171.574-2.21c.095-1.053.096-2.402.096-4.29s-.001-3.236-.096-4.29c-.095-1.039-.274-1.691-.574-2.21a5 5 0 0 0-1.83-1.83c-.519-.3-1.171-.48-2.21-.574C15.237 3.001 13.888 3 12 3s-3.236.001-4.29.096m9.04 3.156c0-.552.45-1.002 1.002-1.002s1.002.45 1.002 1.002s-.45 1.002-1.002 1.002s-1.002-.45-1.002-1.002M12 8.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7M6.5 12a5.5 5.5 0 1 1 11 0a5.5 5.5 0 0 1-11 0"
            ></path>
          </svg>
        );
      default:
        return null;
    }
  };

  const formateDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
  };

  const handleClick = (value, type, id) => {
    if (playMusic._id === id && playMusic.provider === value.name) {
      setPlayMusic((prevState) => ({
        ...prevState,
        isPlay: !prevState.isPlay,
      }));
    } else {
      setPlayMusic({
        provider: value.name,
        link: value?.link,
        isPlay: type,
        _id: id,
      });
    }
  };

  const convertYouTubeToEmbed = (url) => {
    if (!url) return url;

    // Check if it's already an embed URL
    if (url.includes("youtube.com/embed/")) {
      return url;
    }

    // Convert watch URL to embed URL - handles multiple YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/, // youtube.com/watch?v=ID
      /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/, // youtu.be/ID
      /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/, // already embed format
      /(?:youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/, // youtube.com/v/ID
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        const videoId = match[1];
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    return url;
  };

  const isValidYouTubeURL = (url) => {
    if (!url) return false;
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//;
    return youtubeRegex.test(url);
  };

  const handleClickToCopy = (link, id) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const getSpotifyEmbedUrl = (url) => {
    if (!url) return null;
    if (url.includes("open.spotify.com/embed/")) {
      return url.split("?")[0] + "?utm_source=generator";
    }
    const match = url.match(
      /open\.spotify\.com\/(?:embed\/)?([a-z]+)\/([a-zA-Z0-9]+)/,
    );
    if (match)
      return `https://open.spotify.com/embed/${match[1]}/${match[2]}?utm_source=generator`;
    return null;
  };

  const activeEpisode = objectList?.find((v) => v._id === playMusic._id);

  return (
    <section className="podcast-episodes-section" ref={sectionRef}>
      <div className="body-container">
        {/* Section header */}
        <div className="episodes-header">
          <h2>All Episodes</h2>
          {objectList?.length > 0 && (
            <span className="episodes-count">
              <span>{objectList.length}</span>&nbsp;Episodes
            </span>
          )}
        </div>

        <div className="episode-grid">
          {objectList?.map((value, index) => {
            const isActive = playMusic?._id === value?._id;
            const isPlaying = isActive && playMusic?.isPlay;

            return (
              <div
                key={value._id || index}
                className={`episode-card${isActive ? " is-active" : ""}`}
              >
                {/* Artwork / inline YouTube preview */}
                {isActive &&
                isPlaying &&
                playMusic?.provider?.toLowerCase() === "youtube" ? (
                  <div className="ep-youtube-inline">
                    <iframe
                      src={`${convertYouTubeToEmbed(
                        playMusic?.link,
                      )}?autoplay=1&showinfo=0&rel=0&modestbranding=1&controls=1&iv_load_policy=3`}
                      title={value?.title || "YouTube video"}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      referrerPolicy="strict-origin-when-cross-origin"
                    />
                    <button
                      className="ep-youtube-close"
                      onClick={() => setPlayMusic({})}
                      aria-label="Close video"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  </div>
                ) : (
                  <div
                    className={`ep-art${isPlaying ? " ep-art--playing" : ""}`}
                    role="button"
                    tabIndex={0}
                    aria-label={`${isPlaying ? "Pause" : "Play"} ${
                      value?.title
                    }`}
                    onClick={() => {
                      const firstProvider = value?.provider?.[0];
                      if (firstProvider)
                        handleClick(firstProvider, true, value?._id);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        const firstProvider = value?.provider?.[0];
                        if (firstProvider)
                          handleClick(firstProvider, true, value?._id);
                      }
                    }}
                  >
                    {value?.titleImage?.asset?.url ? (
                      <img
                        src={value.titleImage.asset.url}
                        alt={value?.title || "Episode artwork"}
                        loading="lazy"
                      />
                    ) : (
                      <div className="ep-art-placeholder" aria-hidden="true">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="8" r="4" />
                          <path
                            d="M6 20c0-3.314 2.686-6 6-6s6 2.686 6 6"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                    )}
                    <div className="ep-art-overlay" aria-hidden="true">
                      {isPlaying ? (
                        <div className="eq-bars">
                          <span />
                          <span />
                          <span />
                        </div>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 256 256"
                          fill="currentColor"
                        >
                          <path d="M240 128a15.74 15.74 0 0 1-7.6 13.51L88.32 229.65a16 16 0 0 1-16.2.3A15.86 15.86 0 0 1 64 216.13V39.87a15.86 15.86 0 0 1 8.12-13.82a16 16 0 0 1 16.2.3l144.08 88.14A15.74 15.74 0 0 1 240 128" />
                        </svg>
                      )}
                    </div>
                  </div>
                )}

                {/* Card content */}
                <div className="episode-content">
                  {isActive && isPlaying && (
                    <div className="now-playing-row" aria-live="polite">
                      <div className="eq-mini">
                        <span />
                        <span />
                        <span />
                      </div>
                      <span className="now-playing-text">Now Playing</span>
                      <span className="now-playing-provider">
                        via{" "}
                        {playMusic?.provider?.charAt(0).toUpperCase() +
                          playMusic?.provider?.slice(1)}
                      </span>
                    </div>
                  )}
                  {(value?.publishedAt || value?.podcastDuration) && (
                    <div className="episode-meta">
                      {value?.publishedAt && (
                        <span>{formateDate(value.publishedAt)}</span>
                      )}
                      {value?.publishedAt && value?.podcastDuration && (
                        <span className="meta-dot" aria-hidden="true">
                          ·
                        </span>
                      )}
                      {value?.podcastDuration && (
                        <span>{value.podcastDuration}</span>
                      )}
                    </div>
                  )}

                  <h3 className="episode-title">{value?.title}</h3>

                  {value?.shortDescription && (
                    <p className="episode-description">
                      {value.shortDescription}
                    </p>
                  )}

                  <div className="episode-actions">
                    <div className="platform-buttons">
                      {value?.provider?.map((prov, idx) => {
                        const isProvActive =
                          isActive &&
                          playMusic?.provider === prov.name &&
                          playMusic?.isPlay;
                        const provName = prov?.name?.toLowerCase();

                        return (
                          <button
                            key={idx}
                            className={`platform-btn ${provName}-btn${
                              isProvActive ? " active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick(prov, true, value?._id);
                            }}
                            aria-label={`${
                              isProvActive ? "Pause on" : "Play on"
                            } ${prov.name}`}
                            aria-pressed={isProvActive}
                          >
                            {provName === "spotify" && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 256 256"
                                aria-hidden="true"
                              >
                                <path
                                  fill="currentColor"
                                  d="M128 0C57.308 0 0 57.309 0 128c0 70.696 57.309 128 128 128c70.697 0 128-57.304 128-128C256 57.314 198.697.007 127.998.007zm58.699 184.614c-2.293 3.76-7.215 4.952-10.975 2.644c-30.053-18.357-67.885-22.515-112.44-12.335a7.98 7.98 0 0 1-9.552-6.007a7.97 7.97 0 0 1 6-9.553c48.76-11.14 90.583-6.344 124.323 14.276c3.76 2.308 4.952 7.215 2.644 10.975m15.667-34.853c-2.89 4.695-9.034 6.178-13.726 3.289c-34.406-21.148-86.853-27.273-127.548-14.92c-5.278 1.594-10.852-1.38-12.454-6.649c-1.59-5.278 1.386-10.842 6.655-12.446c46.485-14.106 104.275-7.273 143.787 17.007c4.692 2.89 6.175 9.034 3.286 13.72zm1.345-36.293C162.457 88.964 94.394 86.71 55.007 98.666c-6.325 1.918-13.014-1.653-14.93-7.978c-1.917-6.328 1.65-13.012 7.98-14.935C93.27 62.027 168.434 64.68 215.929 92.876c5.702 3.376 7.566 10.724 4.188 16.405c-3.362 5.69-10.73 7.565-16.4 4.187z"
                                />
                              </svg>
                            )}
                            {provName === "youtube" && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 256 180"
                                aria-hidden="true"
                              >
                                <path
                                  fill="currentColor"
                                  d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"
                                />
                                <path
                                  fill="#fff"
                                  d="m102.421 128.06l66.328-38.418l-66.328-38.418z"
                                />
                              </svg>
                            )}
                            <span className="btn-label">
                              {prov.name.charAt(0).toUpperCase() +
                                prov.name.slice(1)}
                            </span>
                          </button>
                        );
                      })}

                      <button
                        className={`platform-btn copy-btn${
                          copiedId === value._id ? " copied" : ""
                        }`}
                        onClick={() =>
                          handleClickToCopy(
                            value?.provider?.[0]?.link || "",
                            value._id,
                          )
                        }
                        aria-label={
                          copiedId === value._id
                            ? "Copied!"
                            : "Copy episode link"
                        }
                        title={copiedId === value._id ? "Copied!" : "Copy link"}
                      >
                        {copiedId === value._id ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 256 256"
                            aria-hidden="true"
                          >
                            <path
                              fill="currentColor"
                              d="M240 88.23a54.43 54.43 0 0 1-16 37L189.25 160a54.27 54.27 0 0 1-38.63 16h-.05A54.63 54.63 0 0 1 96 119.84a8 8 0 0 1 16 .45A38.62 38.62 0 0 0 150.58 160a38.4 38.4 0 0 0 27.31-11.31l34.75-34.75a38.63 38.63 0 0 0-54.63-54.63l-11 11A8 8 0 0 1 135.7 59l11-11a54.65 54.65 0 0 1 77.3 0a54.86 54.86 0 0 1 16 40.23m-131 97.43l-11 11A38.4 38.4 0 0 1 70.6 208a38.63 38.63 0 0 1-27.29-65.94L78 107.31a38.63 38.63 0 0 1 66 28.4a8 8 0 0 0 16 .45A54.86 54.86 0 0 0 144 96a54.65 54.65 0 0 0-77.27 0L32 130.75A54.62 54.62 0 0 0 70.56 224a54.28 54.28 0 0 0 38.64-16l11-11a8 8 0 0 0-11.2-11.34"
                            />
                          </svg>
                        )}
                      </button>
                    </div>

                    {value?.socialMedia?.length > 0 && (
                      <div className="share-icons">
                        {value.socialMedia.map((media) => (
                          <a
                            key={media?.name}
                            href={media?.link}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={`Share on ${media?.name}`}
                          >
                            {renderIcon(media?.name)}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Now Playing Player — Spotify only (YouTube plays inline in card) */}
        {playMusic?._id &&
          playMusic?.isPlay &&
          playMusic?.provider?.toLowerCase() !== "youtube" && (
            <div className="now-playing-section">
              <div className="now-playing-header">
                <span className="now-playing-badge" aria-live="polite">
                  <span className="live-dot" aria-hidden="true" />
                  Now Playing
                </span>
                {activeEpisode && (
                  <h3 className="now-playing-title">
                    {activeEpisode.title}
                    <span className="provider-tag">
                      {" — "}
                      {playMusic.provider?.toLowerCase() === "youtube"
                        ? "YouTube"
                        : "Spotify"}
                    </span>
                  </h3>
                )}
                <button
                  className="close-player-btn"
                  onClick={() => setPlayMusic({})}
                  aria-label="Close player"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>

              {playMusic?.provider?.toLowerCase() === "youtube" && (
                <div className="player-wrapper youtube-player">
                  {isValidYouTubeURL(playMusic?.link) ? (
                    <iframe
                      src={`${convertYouTubeToEmbed(playMusic?.link)}${
                        convertYouTubeToEmbed(playMusic?.link)?.includes("?")
                          ? "&"
                          : "?"
                      }autoplay=1&showinfo=0&rel=0&modestbranding=1&controls=1&iv_load_policy=3&disablekb=1`}
                      title={activeEpisode?.title || "YouTube video player"}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      referrerPolicy="strict-origin-when-cross-origin"
                      onError={() =>
                        setIframeError((prev) => ({
                          ...prev,
                          [playMusic._id]: true,
                        }))
                      }
                    />
                  ) : (
                    <div className="player-error">
                      <p>Invalid YouTube URL. Please check the link.</p>
                    </div>
                  )}
                </div>
              )}

              {playMusic?.provider?.toLowerCase() === "spotify" && (
                <div className="player-wrapper spotify-player">
                  <SpotifyEpisodes data={playMusic} />
                </div>
              )}
            </div>
          )}
      </div>
    </section>
  );
}

export default PodPodCastItem;
